import { MessageHelper } from '#pplx/frontend/components/utils/MessageHelper.js';
import { isPlaceholderResult } from '#pplx/frontend/stream/utils.js';
import { findLast, last } from 'lodash-es';
function isFailedPlaceholder(result) {
    return isPlaceholderResult(result.backend_uuid ?? '') && MessageHelper.isStatusFailed(result);
}
/**
 * The last result anchors the next submission (`last_backend_uuid`). A failed
 * optimistic placeholder has no backend entry behind its uuid, so chaining to
 * it would fail every follow-up until reload; skip it when a real entry exists.
 */
export function selectLastResult(visibleResults) {
    return findLast(visibleResults, (result) => !isFailedPlaceholder(result)) ?? last(visibleResults);
}
//# sourceMappingURL=ResultsProviderShared.js.map